import styles from './TabBar.module.css';

const TabBar = ({ tabs, activeTab, onTabChange, centered }) => {
  return (
    <div className={`${styles.tabBar} ${centered ? styles.tabBarCentered : ''}`}>
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`${styles.tabItem} ${activeTab === tab.id ? styles.tabItemActive : ''}`}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default TabBar;
